import { render, h, Component } from 'preact';
import Portal from 'preact-portal';
import style from './style';
import root from '@components/root';

const overflowStyles = 'max-height: 90vh;overflow:scroll;';

class Popover extends Component {
  state = {
    hidden: true,
  };
  _calculateFitOnAxis = (center, elementDimension, start = 0, stop = 1280) => {
    // Check if element goes over
    if (center + elementDimension * 0.5 > stop) {
      return stop - elementDimension * 0.5;
    } else if (center - elementDimension * 0.5 < start) {
      return start + elementDimension * 0.5;
    } else {
      return center;
    }
  };

  propagateClose = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  setPosition = element => {
    if (!element) {
      return;
    }
    root.setTimeout(() => {
      const e = this.state.e;
      this.element = element;

      let windowXStart =
          document && window ? document.scrollLeft || window.pageXOffset : 0,
        windowXEnd =
          document && window ? windowXStart + window.innerWidth : 1280,
        windowYStart =
          document && window ? document.scrollTop || window.pageYOffset : 0,
        windowYEnd =
          document && window ? windowYStart + window.innerHeight : 1280,
        centerX = windowXStart + e.x,
        centerY = windowYStart + e.y;

      let baseElementRects;
      if (!e.x) {
        baseElementRects =
          baseElementRects || this.base.getBoundingClientRect();
        centerX =
          windowXStart + baseElementRects.left + baseElementRects.width / 2;
      }

      if (!e.y) {
        baseElementRects =
          baseElementRects || this.base.getBoundingClientRect();
        centerY =
          windowYStart + baseElementRects.top + baseElementRects.height / 2;
      }

      let offsetX = element.offsetWidth,
        offsetY = element.offsetHeight;

      let realX = this._calculateFitOnAxis(
          centerX,
          offsetX,
          windowXStart,
          windowXEnd
        ),
        realY = this._calculateFitOnAxis(
          centerY,
          offsetY,
          windowYStart,
          windowYEnd
        );

      this.setState({
        hidden: false,
        style: `${
          offsetY > windowYEnd - windowYStart ? overflowStyles : ''
        }top:${realY}px;left:${realX}px;-webkit-transform: translate3d(-50%,-50%,0);transform: translate3d(-50%,-50%,0);`,
      });
    });
  };

  getChildContext() {
    return {
      closePopOver: () => this.setState({ hidden: true }, this.propagateClose),
    };
  }
  componentWillUnmount() {
    if (document && this.element && this.element.parentNode)
      render(null, document.body, this.element);
  }

  render(props, state) {
    return (
      <div
        {...props}
        onClick={e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (this.state.hidden === false) {
            return;
          }
          this.setState({ hidden: false, e });
        }}
        onFocusIn={e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.target.blur();
          window.setTimeout(() => {
            if (this.state.hidden === false) {
              return;
            }
            this.setState({ hidden: false, e });
          }, 64);
        }}
      >
        {props.toggle}
        {!state.hidden ? (
          <Portal into="body">
            <div
              class={style.backsplash}
              onClick={() => {
                this.setState({ hidden: true }, this.propagateClose);
              }}
            />
          </Portal>
        ) : null}
        {!state.hidden ? (
          <Portal into="body">
            <div
              class={style.popover}
              ref={this.setPosition}
              style={state.style ? state.style : 'opacity:0'}
            >
              {props.children[0]}
            </div>
          </Portal>
        ) : null}
      </div>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./components/popover/index.js